"use server";

import { validateParams } from "@/lib/utils";
import z from "zod";
import { ActionResult } from "@/types/server-action";
import { auth } from "@/auth";

const searchVehicleSchema = z
  .object({
    chassisNumber: z
      .string()
      .trim()
      .min(1)
      .regex(
        /^[a-zA-Z0-9]{17}/,
        "Le numéro de Chassis doit être une suite de 17 caractères alpha-numériques.",
      )
      .optional(),
    orderNumber: z
      .string()
      .min(1)
      .regex(/^\d{6}/)
      .optional(),
    orderYear: z
      .string()
      .trim()
      .min(1)
      .regex(/^\d{4}/)
      .optional(),
  })
  .refine(
    (data) =>
      (!!data.chassisNumber && !data.orderNumber && !data.orderYear) ||
      (!data.chassisNumber && !!data.orderNumber && !!data.orderYear),
    {
      message:
        "Renseignez soit un numéro de chassis, soit un numéro et une année de commande",
    },
  );

export async function searchVehicle(
  params: z.infer<typeof searchVehicleSchema>,
): Promise<ActionResult> {
  try {
    const session = await auth();
    const { chassisNumber, orderNumber, orderYear } = validateParams(
      searchVehicleSchema,
      params,
    );

    const kvps = session?.data.kvps.current;
    const brand = kvps?.parts.brand;

    // await call MuleSoft

    // VU => lettre N
    return {
      success: true,
      data: {
        vin: "123",
        brand: "Volkswagen",
        model: "Crafter 35 L3H3",
        color: "Blanc Candy",
        engine: "2.0 TDI 140ch",
        transmission: "Manuelle 6 vitesses",
        options: ["Pack Carrossier", "Préparation Utilitaire"],
        productionDate: "2024-02-20",
        status: "Disponible - Nécessite Carrossage",
        isBodywork: true,
        hasTradeIn: false,
      },
    };
  } catch (error) {
    console.error(error);

    return {
      success: false,
      message: "Une erreur serveur est survenue.",
    };
  }
}
